module.exports = __webpack_public_path__ + "static/media/3DPPA16.ff0d656a.jpg";